import { Translatable } from "@icc/shared/helpers";

/** Typ prowadzenia */
export class GuidanceType {
    id: number;
    /** Nazwa */
    @Translatable({ model: 'BlindGuidanceTypes' })
    name: string;
    /** Nazwa tylko dla samego pakietu żaluzji */
    @Translatable({ model: 'BlindGuidanceTypes' })
    nameOnlyShutter: string;
    /** Opis */
    description: string;
    /** Opis tylko dla samego pakietu żaluzji */
    descriptionOnlyShutter: string;
    /** Rodzaj */
    type: Guidance;
    /** Czy domyślne prowadzenie */
    default?: boolean;
    /** Kolejność */
    order?: number;
    /** Domyślny odstęp na lamelę [mm] */
    defaultSpaceLamellaMm?: number;
}

/**
 * Rodzaj prowadzenia
 *
 * `guide` - prowadnica
 * `cord` - prowadzenie linkowe
 * `guide_preparation` - przystosowanie pod prowadnice
 * `cord_preparation` - przystosowanie pod prowadzenie linkowe
 * `guide_adaptation` - dostosowanie pod prowadnice z oferty (dostępny wybór poszczególnych prowadnic)
 */
export type Guidance = 'guide' | 'cord' | 'guide_preparation' | 'cord_preparation' | 'guide_adaptation';